import { render, staticRenderFns } from "./InputSpinQuiz.vue?vue&type=template&id=32bace04&scoped=true&"
import script from "./InputSpinQuiz.vue?vue&type=script&lang=js&"
export * from "./InputSpinQuiz.vue?vue&type=script&lang=js&"
import style0 from "./InputSpinQuiz.vue?vue&type=style&index=0&id=32bace04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bace04",
  null
  
)

export default component.exports